import api from "../util/api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { BuscaConsignatarioModel } from "../models/consignatario/chamadas/buscaConsignatarioModel";
import { setLoading } from "../redux/slices/configuracoes/configuracoesSlice";
import { toastError, toastSucess } from "../util/toast";
import { setModalDadosUsuarioConsignatario, setModalDeletarConsignatario, setPageConsignatario } from "../redux/slices/consignatario/consignatarioSlice";

export const sincronizarConsignatario = createAsyncThunk("/Consignatario/SincronizarConsignatario", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.post("/Consignatario/SincronizarConsignatario", null, { params: { idEmpresa: payload.value } });
    toastSucess("Os consignatários foram sincronizados com sucesso");
    dispatch(setLoading(false));

    dispatch(buscarConsignatario(payload.busca));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});

export const gerarDadosUsuarioConsignatario = createAsyncThunk("/Consignatario/GerarDadosUsuarioConsignatario", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.post("/Consignatario/GerarDadosUsuarioConsignatario", payload.value);
    toastSucess("Dados de usuário do consignatário gerado com sucesso");
    dispatch(setModalDadosUsuarioConsignatario(false));
    dispatch(setLoading(false));

    dispatch(buscarConsignatario(payload.busca));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});

export const buscarConsignatario = createAsyncThunk("/Consignatario/BuscarConsignatario", async (args: BuscaConsignatarioModel) => {
  try {
    const data = await api.get("/Consignatario/BuscarConsignatario", {
      params: args,
    });
    return data.data.data;
  } catch (error: any) {
    throw new Error(error.response.data.Message);
  }
});

export const atualizarConsignatario = createAsyncThunk("/Consignatario/AtualizarConsignatario", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.put("/Consignatario/AtualizarConsignatario", payload.value);
    toastSucess("Consignatário atualizado com sucesso");
    dispatch(setPageConsignatario("geral"));
    dispatch(setLoading(false));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});

export const atualizarConsignatarioAtivo = createAsyncThunk("/Consignatario/AtualizarConsignatarioAtivo", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.put("/Consignatario/AtualizarConsignatarioAtivo", null, {
      params: payload.value,
    });
    toastSucess("Status de ativo do Consignatário atualizado com sucesso");
    dispatch(setLoading(false));

    dispatch(buscarConsignatario(payload.busca));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});

export const deletarConsignatario = createAsyncThunk("/Consignatario/DeletarConsignatario", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.delete("/Consignatario/DeletarConsignatario", {
      params: payload.value,
    });
    toastSucess("Consignatário removido com sucesso");
    dispatch(setModalDeletarConsignatario(false));
    dispatch(setLoading(false));

    dispatch(buscarConsignatario(payload.busca));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});
